import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import './Prices.scss';
import { Prices as PricesComponent } from '../../components/Prices/Prices';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import {Helmet} from 'react-helmet-async';

const Prices = () => {
    
    return (
        <>
            <Helmet>
                            <title>Złota Centrum Zdrowia | Cennik</title>
                            <meta
                              name="description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                            {/* Open Graph / Facebook */}
                            <meta property="og:type" content="website" />
                            <meta property="og:url" content={window.location.href} />
                            <meta property="og:title" content="Złota Centrum Zdrowia | Cennik" />
                            <meta
                              property="og:description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                    
                            {/* Twitter */}
                            <meta property="twitter:card" content="summary" />
                            <meta property="twitter:url" content={window.location.href} />
                            <meta property="twitter:title" content="Złota Centrum Zdrowia | Cennik" />
                            <meta
                              property="twitter:description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                          </Helmet>
            <Navbar />
            <ServiceBanner title='Cennik' />
            <div className="prices-container container section-p section-m">
                <SectionTitle title='' description='Zapraszamy do zapoznania się z naszą ofertą. W razie wątpliwości jesteśmy do Państwa dyspozycji.' />
            </div>
            <PricesComponent />

            <Footer />
        </>
    );
};

export default Prices;